; (function ($) {
    'use strict';

    lightbox.option({
        'resizeDuration': 200,
        'wrapAround': true,
        albumLabel: 'Image %1 de %2'
    });
}(jQuery));